<template>
  <navbar>
    <my-button @click="$router.push('/profile')">profile</my-button>
  </navbar>

  <div class="cocktail">
    <div>
      <cocktail :cocktail="cocktail" :key="cocktail.id"></cocktail>
    </div>
    <button class="btn_order" @click="order(cocktail.id)"
      v-if="isOrder">Заказать</button>
    <button class="btn_order" style="color: #00df00; border: none;"
      v-if="isOk">Ok</button>
  </div>
</template>


<script>
import Navbar from '@/components/Navbar.vue';
import Cocktail from '@/components/Cocktail.vue';
// import ky from 'ky';

export default {
  components: {
    Navbar, Cocktail
  },
  data() {
    return {
      isOrder: true,
      isOk: false,
      cocktail: {},
    }
  },
  methods: {
    async get_cocktail(cid) {
      let res = await fetch(`/api/bar/cocktail/${cid}`, {
      // let res = await fetch(`/bar/cocktail/${cid}`, {
        method: "POST",
        headers: {"content-type": "application/json"},
      });

      if (res.status === 200) {
        let data = await res.json();
        // console.log(res);
        // console.log(data);
        this.cocktail = data['cocktail'];
      }
    },
    async order(cid) {
      console.log(cid);
      let res = await fetch(`/api/bar/order`, {
      // let res = await fetch(`/bar/order`, {
        method: "POST",
        headers: {"content-type": "application/json"},
        body: JSON.stringify({
          id: cid,
        })
      });

      if (res.status === 200) {
        let data = await res.json();
        // console.log(res);
        // console.log(data);
        this.isOrder = false;
        this.isOk = true;
      }
    },
    async isauth() {
      let res = await fetch('/api/auth/isauth', {
        method: "POST",
        headers: {"content-type": "application/json"},
      });
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data['auth']);
        if (!data['auth']) {
          this.$router.push('/auth/log_in');
        }
      }
    }
  },
  mounted() {
    this.isauth();
    this.get_cocktail(this.$route.params.cid);
  }
}
</script>


<style scoped>
.cocktail {
  padding: 35px;
}
.btn_order {
  font-size: 50px;
  margin-top: 25px;
  border: 3px solid #00df00;
  border-radius: 15px;
  width: 100%;
  background-color: white;
}
.btn_order:active {
  background-color: var(--bar-color-back);
}
</style>
